import DetailPoints from "../DetailPoints";
import React, { useState } from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import { FaCalendarAlt, FaGlobe } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCarcdsf2Asv = (props) => {
  const { resultRetraite,ClientConjoint } = props;
  const context = useContext(AppContext);

  let [openModal, setOpenModal] = useState(false);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };
  return (
    <>   {context.state['Carriere'+ClientConjoint].filter((Carriere) => Carriere.Nature === "Carcdsf2" && Carriere.ParamCotisations.Conventionne === "oui")
                    .length > 0 && (
        <div className="card">
          <div className="category-column">
            <label className="prise-en-charge-cell-label" style={{ marginBottom: 0 }}>
              PCV CARSF
            </label>
          </div>
          <div 
            className="value-column"
            onClick={() => {
              setOpenModal(true);
            }}
          >
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarcdsf2}
              readOnly
             style={{ cursor: "pointer", color: "#1f2937", backgroundColor: "white" }}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
          </div>
          <div className="value-column">
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCarcdsf2Supp}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinCarcdsf2Supp",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={resultRetraite?.InfosRetraite?.Carcdsf2?.General?.AsvPointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Carcdsf2?.General?.AsvPointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
            <DetailPoints caisse="Carcdsf2" regime="Asv" champ="AsvPointCalcule" libelle="CARCDSF2 ASV" />
          </div>
        </div>
      )}

      <Modal
        width="30%"
        height="44%"
        title=" POINTS PCV CARSF"
        icon={<FaGlobe />}
        visible={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <Column fill>
                      <Row>
                        <Column>
                          <TextField
                          labelIcon ={<FaCalendarAlt />}
                            label="Avant 1995"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarcdsf2Avant1995}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarcdsf2Avant1995")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                          labelIcon ={<FaCalendarAlt />}
                            label="Entre 1995 et 2005"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarcdsf219952005}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarcdsf219952005")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                          labelIcon ={<FaCalendarAlt />}
                            label={"Entre 2006 et " +context.state.TableauPoints.AnneeFinCarcdsf2Supp}
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarcdsf2Apres2006}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCarcdsf2Apres2006")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                    </Column>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                setOpenModal(false);
              },
            },
          }}
        />
      </Modal>
    </>
  );
};
export default PointCarcdsf2Asv;
